import React from 'react'

export const Pill = ({ text, color, className, ...otherProps }) => (
  <span
    {...otherProps}
    className={`Pill ${color || 'primary'} ${className || ''}`}
  >
    {text}
  </span>
)

export default Pill
